import { render, staticRenderFns } from "./patrolItemPop.vue?vue&type=template&id=2fb28c87"
import script from "./patrolItemPop.vue?vue&type=script&lang=js"
export * from "./patrolItemPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fb28c87')) {
      api.createRecord('2fb28c87', component.options)
    } else {
      api.reload('2fb28c87', component.options)
    }
    module.hot.accept("./patrolItemPop.vue?vue&type=template&id=2fb28c87", function () {
      api.rerender('2fb28c87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/patrol/patrolItemPop.vue"
export default component.exports